<template>
  <b-collapse class="card" :open.sync="isOpen">
    <div slot="trigger" class="card-header">
      <p class="card-header-title">
        {{ $t('filters') }}
      </p>
      <a class="card-header-icon">
        <b-icon
          pack="fa"
          size="is-small"
          :icon="isOpen ? 'chevron-up' : 'chevron-down'"
          type="is-dark"
        ></b-icon>
      </a>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="field">
          <p class="control has-icons-left">
            <input class="input" v-model="search" :placeholder="$t('filterByParticipants')">
            <span class="icon is-small is-left"><i class="fa fa-search"></i></span>
          </p>
        </div>

        <b-checkbox v-model="typesFilter" v-for="type in types" :key="type" :native-value="type">
          <b-tag :type="getTypeColor(type)">{{ $t('types.' + type) }}</b-tag>
        </b-checkbox>
      </div>
    </div>
  </b-collapse>
</template>

<script>
  import * as types from '@/store/mutation-types'
  import { globalMethods } from '@/shared/mixins'

  export default {
    name: 'event-filters',
    mixins: [globalMethods],
    data () {
      return {
        types: [
          'SWEET',
          'SAVORY',
          'MISCELLANEOUS',
          'ACCESSORY',
          'SOFT_DRINK',
          'ALCOHOL'
        ],
        isOpen: false
      }
    },
    computed: {
      search: {
        get () { return this.$store.state.filters.search },
        set (value) { this.$store.commit(types.UPDATE_SEARCH, value) }
      },
      typesFilter: {
        get () { return this.$store.state.filters.types },
        set (value) { this.$store.commit(types.UPDATE_TYPES, value) }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EventFilters.vue